import React from 'react';
import { Avatar as ChakraAvatar, AvatarProps as ChakraAvatarProps } from '@chakra-ui/avatar';

export default function Avatar(props: ChakraAvatarProps) {
  return <ChakraAvatar {...props} />;
}
